import axios from 'axios'
import { TEST_URl } from '@/utils/constants.js'

const defaultBaseUrl = `${process.env.VUE_APP_BASE_URL}`
const testUrl = localStorage.getItem(TEST_URl)
const baseUrl = testUrl || defaultBaseUrl

export async function getAllNotificationServices (payload) {
  const res = await axios.get(
    `${baseUrl}/notifications?size=${payload.size}&page=${payload.page}`
  )
  return res
}
export async function getAllUnreadNotificationServices (payload) {
  const res = await axios.get(
    `${baseUrl}/notifications?size=${payload.size}&page=${payload.page}&isRead=${payload.isRead}`
  )
  return res
}
export async function markANotificationAsReadService (id) {
  const res = await axios.post(`${baseUrl}/notifications/${id}`)
  return res
}
export async function markAllNotificationsAsReadService () {
  const res = await axios.post(`${baseUrl}/notifications`)
  return res
}
